@if (isVisible) {
  <div class="chatbot-container">
    <!-- Chat Panel -->
    <div
      class="chat-panel-wrapper"
      [@panelAnimation]="isOpen ? 'open' : 'closed'"
      (@panelAnimation.done)="onAnimationDone($event)"
    >
      @if (showPanel) {
        <app-chat-panel></app-chat-panel>
      }
    </div>

    <!-- FAB Button -->
    <button
      mat-fab
      class="chat-fab"
      [class.is-close]="isOpen"
      (click)="toggleChat()"
      [attr.aria-label]="isOpen ? closeLabel : openLabel"
    >
      <mat-icon>{{ isOpen ? 'close' : 'smart_toy' }}</mat-icon>
    </button>
  </div>
}
